module.exports = "https://static.im-cdn.com/mjc/storefront/Sakra/static/media/whiteClose.fd7383f5.svg";